export enum MyFilesScopes {
  CAN_VIEW = 'can_view_my_files',
  CAN_UPLOAD = 'can_upload',
  CAN_DELETE = 'can_delete',
  CAN_CREATE = 'can_create',
  CAN_VIEW_TAGS = 'can_view_tags',
  CAN_DELETE_TAGS = 'can_delete_tags',
  CAN_MARK_FOR_REVIEW = 'can_mark_for_review',
}
